export default __webpack_public_path__ + "static/case-1-a9c83d2a4dd7710de851eb9fcfb12a3f.png";